import React, {useState, useEffect} from "react";
import {hopnLanguageArray} from "@/utils/functions.js";
import ModalHeader from "@/customComponents/uiComponents/modal/ModalHeader.jsx";
import axios from "axios";
import {flightService, FLIGHT_API_HEADERS} from "@/services/flightService";
import {storage, STORAGE_KEYS} from "@/utils/storage";
import {bigClose, longArrowLeft, clockTrack, plane2dIcon, arrowRightWhite, arrRight} from "@img/index.js";
import {ModalFooter} from "../Components/BookingModalShell.jsx";
import {rideDateYMD as formatDateYMD} from "@/utils/dateUtils.js";

const BASE_URL = "https://aerodatabox.p.rapidapi.com";

export function FlightAirlines(props) {
    const [innerModal, setInnerModal] = useState(false);
    const [flightNumberMessage, setFlightNumberMessage] = useState(false);
    const [flights, setFlights] = useState([]);
    const [selectedFlight, setSelectedFlight] = useState(null);
    const [loading, setLoading] = useState(true);

    const departureAirport = storage.get(STORAGE_KEYS.DEPARTURE_AIRPORT);
    const arrivalAirport = storage.get(STORAGE_KEYS.AIRPORT_DETAILS);
    const rideDate = storage.get(STORAGE_KEYS.RIDE_DATE);

    const fromLocal = rideDate ? `${formatDateYMD(rideDate)}T00:00` : null;
    const toLocal = rideDate ? `${formatDateYMD(rideDate)}T23:59` : null;

    useEffect(() => {
        if (!departureAirport || !arrivalAirport || !fromLocal || !toLocal) return;

        const fetchFlights = async () => {
            setLoading(true);
            try {
                const res = await axios.get(
                    `${BASE_URL}/flights/airports/iata/${departureAirport.iata}/${fromLocal}/${toLocal}`,
                    {
                        headers: FLIGHT_API_HEADERS,
                        params: {
                            withLeg: "true",
                            direction: "Departure",
                            withCancelled: "false",
                            withCodeshared: "true",
                            withCargo: "false",
                            withPrivate: "false",
                        },
                    }
                );
                const departures = res.data?.departures || [];
                const relevantFlights = departures.filter(
                    (flight) => flight.movement.airport.iata === arrivalAirport.code
                );
                setFlights(relevantFlights);
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchFlights();
    }, [departureAirport, arrivalAirport, fromLocal, toLocal]);


    const handleFlightSelection = (flight) => {
        setSelectedFlight(flight);
        storage.set(STORAGE_KEYS.SELECTED_FLIGHT, flight);
    };

    const formatTime = (dateTimeString) => {
        if (!dateTimeString) return "";
        const date = flightService.parseLocalTime(dateTimeString);
        return date.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'});
    };

    const formatDate = (dateTimeString) => {
        if (!dateTimeString) return "";
        const date = flightService.parseLocalTime(dateTimeString);
        return date.toLocaleDateString([], {weekday: 'short', month: 'short', day: 'numeric'});
    };

    return (
        <>
            <ModalHeader
                title="Flight Details"
                extraClasses=""
                totalSteps={1}
                cancelButton={false}
                cancelButtonType="text"
                backStep="flightAirportLists"
                showBackButton={true}
                enableEditModeOnBackButton={false}
                setStep={props.setStep}
            />

            <div className="hopn-airlines modalPages-spacing">
                <div className="upper-modal" style={{display: innerModal ? 'flex' : 'none'}} hopn-data-category="modal_car_selection">
                    <div className="upper-modal-inner">
                        <div className="hopn-modal-header">
                            <div className="hopn-modal-header-top">
                                <div className="inner"></div>
                                <div className="inner">
                                    <button
                                        className="go_back"
                                        onClick={() => setInnerModal(false)}
                                        hopn-data-index="mobile_close"
                                        style={{marginLeft: 'auto'}}
                                    >
                                        <img alt={hopnLanguageArray("modal_car_selection", "mobile_close_alt", "Close Popup")} src={bigClose} hopn-data-index="mobile_close_alt"/>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="hopn-flight-manual">
                            <h6 className="hopn-flight-title">Enter Flight Number</h6>
                            <form className="hopn-flight-input-wrap" onSubmit={(e) => {
                                e.preventDefault();
                                setFlightNumberMessage(true);
                                setInnerModal(false);
                            }}>
                                <input type="text" name="flight_number" placeholder="E.g. Ac4567"/>
                                <button type="submit">Add</button>
                            </form>
                        </div>
                    </div>
                </div>

                <div className="upper-modal" style={{display: flightNumberMessage ? 'flex' : 'none'}} hopn-data-category="modal_car_selection">
                    <div className="upper-modal-inner">
                        <div className="hopn-modal-header">
                            <div className="hopn-modal-header-top">
                                <div className="inner">
                                    <button
                                        className="go_back"
                                        onClick={() => {
                                            setFlightNumberMessage(false);
                                            setInnerModal(true);
                                        }}
                                        hopn-data-index="mobile_go_back"
                                    >
                                        <img alt={hopnLanguageArray("modal_car_selection", "mobile_go_back_alt", "Go back")} src={longArrowLeft} hopn-data-index="mobile_go_back_alt"/>
                                    </button>
                                </div>
                                <div className="inner">
                                    <button
                                        className="go_back"
                                        onClick={() => setFlightNumberMessage(false)}
                                        hopn-data-index="mobile_close"
                                        style={{marginLeft: 'auto'}}
                                    >
                                        <img alt={hopnLanguageArray("modal_car_selection", "mobile_close_alt", "Close Popup")} src={bigClose} hopn-data-index="mobile_close_alt"/>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="hopn-flight-manual-message">
                            <h3><img src={clockTrack}/> Your pick-up time is now based on your arrival</h3>
                            <p>The driver will track your flight and wait for 45 minutes after they arrive. We'll notify you when the driver is on their way.</p>
                            <button>0k</button>
                        </div>
                    </div>
                </div>

                <div className="hopn-date-info-layout">
                    <div className="inner-tab">
                        <div className="hopn-airlines-select">
                            <div className="hopn-airlines-inner">Select the airline you're flying with</div>
                            <div className="hopn-airlines-inner">Select an airline</div>
                        </div>
                        <div className="hopn-airlines-cards">
                            {loading ? (
                                <div className="hopn-airlines-card loading">Loading flights...</div>
                            ) : flights.length > 0 ? (
                                flights.map((flight, index) => (
                                    <div
                                        key={index}
                                        className={`hopn-airlines-card ${selectedFlight === flight ? "active" : ""}`}
                                        onClick={() => handleFlightSelection(flight)}
                                    >
                                        <div className="hopn-airlines-card-top">
                                            {flight.airline.name} <span>– {flight.number}</span>
                                        </div>
                                        <div className="hopn-airlines-card-body">
                                            <div className="hopn-airlines-from">
                                                <span className="hopn-airlines-city">{flight.movement.airport.name} ({flight.movement.airport.iata})</span>
                                                <span className="hopn-airlines-time">{formatTime(flight.movement.scheduledTime.local)}</span>
                                                <span className="hopn-airlines-date">{formatDate(flight.movement.scheduledTime.local)}</span>
                                            </div>

                                            <div className="hopn-airlines-icon">
                                                <img decoding="async" src={plane2dIcon}/>
                                            </div>

                                            <div className="hopn-airlines-to">
                                                 <span className="hopn-airlines-city">{arrivalAirport.name} ({arrivalAirport.code})</span>
                                                <span className="hopn-airlines-time">{formatTime(flight.movement.revisedTime?.local || flight.movement.scheduledTime.local)}</span>
                                                <span className="hopn-airlines-date">{formatDate(flight.movement.revisedTime?.local || flight.movement.scheduledTime.local)}</span>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="hopn-airlines-card">No flights found for this route.</div>
                            )}
                        </div>
                        <div className="hopn-airlines-change">Not your flight? <a href="#">Change it here</a></div>
                    </div>
                    <div className="inner-tab hopn-banner-right">
                        <div className="hopn-airlines-right">
                            <div className="hopn-banner-right-inner">
                                <button className="clearStyle" onClick={() => setInnerModal(true)}>
                                    Or, enter flight number manually <span><img decoding="async" src={arrRight}/></span>
                                </button>
                                <div className="flight-delayed">
                                    <img decoding="async" src={clockTrack}/>
                                    <div className="flight-delayed-inner">
                                        <h5>Flight delayed?</h5>
                                        <p>No problem. Your captain will track your flight and adjust your pickup time automatically</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ModalFooter>
                <button className="hopn-add-passenger-button time"
                        disabled={!selectedFlight}
                        onClick={() => {
                            if (selectedFlight) props.setStep('passengerQuantity');
                        }}
                >
                    Continue
                    <img decoding="async" src={arrowRightWhite} alt="+Date & Time"/>
                </button>
            </ModalFooter>
        </>
    );
}
export default FlightAirlines;
